import React, { FC } from 'react';
import Grid from '@mui/material/Grid';
import Breadcrumb from '@/components/fasce/Breadcrumb';
import ProductDetailTitle from '@/components/fasce/ProductDetailTitle';
import ProductDetailImage from '@/components/fasce/ProductDetailImage';
import ProductOverlayTable from '@/components/fasce/ProductOverlayTable';
import ProductOverlayAccordion from '@/components/fasce/ProductOverlayAccordion';
import { WPLinks_VARIANTE, WPLinks_COLORE, WPLinks_SIZE } from '@/data/wp/operations/queries/fragments/link';
import useTranslation from 'next-translate/useTranslation';
import { Translate } from 'next-translate';
import { getTechnicalDataAttributeKey, getTechnicalDataAttributeValue, normalizeAzureAssetUrl } from '@/data/hcl/sdk/utils';

interface ProductDetailModalContentProps {
  productData: Record<string, any>;
  breadcrumbs: any;
  attachments: any;
  garanzia: string;
  defaultImage: string;
  defaultThumb: string;
  appUso: string;
};

type ModalData = {
    breadcrumb?: React.ReactElement;
    title?: React.ReactElement;
    slider?: React.ReactElement;
    tables?: React.ReactElement[];
    accordion?: React.ReactElement;
}

const ProductDetailModalContent: FC<ProductDetailModalContentProps> = ({ productData, breadcrumbs, attachments, garanzia, defaultImage, appUso }) => {
  // TODO: generare i componenti a partire dalle informazioni in productData
  const {t} = useTranslation('common');
  const modalData: ModalData = getModalData(productData?.data?.productViewFindProductByPartNumber?.catalogEntryView[0], breadcrumbs, attachments, garanzia, defaultImage,appUso, productData?.data?.name, t);
  //const modalData: ModalData | null = productData.sku === 'EXAMPLE-VERSIONI' ? MOCK_Versioni: MOCK_Attributi;

  return (<Grid container rowSpacing={0} sx={{ position: 'relative' }}>
    {modalData.breadcrumb &&
      modalData.breadcrumb
    }
    {modalData.title &&
      modalData.title
    }
    <Grid item xs={12} sm={7}>
      {modalData.slider &&
        modalData.slider
      }
      {modalData.tables && modalData.tables.map((singleTable, index) => {
        return (
          <React.Fragment key={index}>
            {singleTable}
          </React.Fragment>
        )
      })}
    </Grid>
    <Grid item xs={12} sm={5}>
      {modalData.accordion &&
        modalData.accordion
      }
    </Grid>
  </Grid>)
}

export default ProductDetailModalContent;

// TODO: rimuovere questi mock a seguito dell'ingegnerizzazione (creare comunque mock della response in \mocks\wcs\graphql\modalProduct.js, vedi anche ProductDetailModal.tsx)



/**
 * Get the value/values from the attribute
 * 
 * @param productData 
 * @param attributeName 
 * @returns 
 */
function getTechnicalDataRowValue(productData: Record<string, any>, attributeName:string){

  let value = '';

  if (productData?.technicalData[attributeName][0]?.values?.length == 1) {
    value = productData?.technicalData[attributeName][0]?.values[0]?.value;
  } else {
    let values:string[] = [] as string[];
    productData?.technicalData[attributeName][0]?.values.forEach((attribute: any) => {
      values.push(attribute.value);
    });
    value = values.join(",");
    
    // TMP --> CLEAN DUPLICATES
    let tmpValues = value.split(",");
    let uniqueValues = tmpValues.filter(function(item, pos) {
      return tmpValues.indexOf(item) == pos;
    });
    value = uniqueValues.join(", ");
    // FINE TMP 
  }

  if (attributeName === 'att_FattoreDiPotenza') {
    value = productData?.technicalData['att_SegnoFattorePotenza'][0]?.values[0]?.value  + ' ' + value;
  }

  return value;
}


function getModalData(productData: Record<string, any>, breadcrumbs: any, attachments: any, garanzia: string, defaultImage: string, appUso: string, parentProductName: string, t: Translate) {

  productData = Object.assign({}, productData, {selected:false})
  // const newProductData = integrateResponse(productData);
  // productData = Object.assign({}, newProductData, {selected:false})

  productData.iconList = [];

  productData.attachmentsParentProd = attachments;

  /* let origin = `${window.location.origin.toString()}`;

  console.log('origin: %s',origin)

  let icons = productData?.attachments?.filter((item: { usage: string; }) => item.usage.includes('Pittogrammi'));
  icons?.forEach(async (icon: any) => {
      let iconObj = {
        icon: icon.attachmentAssetPath.replace('https://' + process.env.NEXT_PUBLIC_HCL_HOST_ASSETS,origin),
          iconTooltip: icon.longdesc
      }
      console.log('asset: %s',icon.attachmentAssetPath.replace('https://' + process.env.NEXT_PUBLIC_HCL_HOST_ASSETS,origin))
      productData?.iconList.push(iconObj);
  }); */

  let attributes = productData?.attributes;
  productData.technicalDataRow = [];
  productData.technicalDataAttr = getTechnicalDataAttributeKey();
  productData.technicalData = getTechnicalDataAttributeValue(productData.technicalDataAttr, attributes);

  productData?.technicalDataAttr.forEach((attribute: any) => {
    if(productData?.technicalData[attribute].length > 0) {
      let valueAsDesc = getTechnicalDataRowValue(productData, attribute);
      if(valueAsDesc !== undefined && valueAsDesc.trim() !== '') {
        productData?.technicalDataRow.push({
          title: productData?.technicalData[attribute][0].name,
          desc: valueAsDesc
        });
      }
    }
  });

  productData.attachmentsGrouped = [];
  let attachmentsGroupMapping = ['documentazione-title','disegni-2d-3d-title','fileilluminotecnici-title','schedatecnica-title','zipdisegni-title','zipdocumentazione-title','zipfileilluminotecnici-title','ziptutti-title'];
  let accordionsGroupMap: any = {};
  attachmentsGroupMapping.forEach(item => {
    accordionsGroupMap[item] = {
      accordionType: item,
      accordionTitle: t(item),
      accordionRow: [],
      accordionBtn: []
    };
    if(process.env.NEXT_PUBLIC_ENABLE_ZIP === 'true') {
      accordionsGroupMap[item].accordionBtn.push(
        {
          __typename: "DefaultTemplate_Fasce_Fasce_GrayCard_Links_LinkInterno",
          linkInterno: {
            id: "cG9zdDoxNA==",
            slug: "download",
            uri: "/download/",
            title: "download"
          },
          label: t('download-zip', {}, {default: 'Download .zip'}),
          target: null,
          variante: WPLinks_VARIANTE.filledButton,
          colore: WPLinks_COLORE.primary,
          dimensione: WPLinks_SIZE.large
        }
      )
    }
  });

  productData?.attachments?.forEach((attachment: any) => {
    if(attachment.usage === 'BIM'){
      accordionsGroupMap['disegni-2d-3d-title'] = getAccordion(attachment, accordionsGroupMap['disegni-2d-3d-title']);
    }
    if(attachment.usage === 'DisegnoTecnico'){
      accordionsGroupMap['disegni-2d-3d-title'] = getAccordion(attachment, accordionsGroupMap['disegni-2d-3d-title']);
    }
    if(attachment.usage === 'DisegnoTecnico3D'){
      accordionsGroupMap['disegni-2d-3d-title'] = getAccordion(attachment, accordionsGroupMap['disegni-2d-3d-title']);
    }
    if(attachment.usage === 'DisegnoTecnicoJPG'){
      accordionsGroupMap['disegni-2d-3d-title'] = getAccordion(attachment, accordionsGroupMap['disegni-2d-3d-title']);
    }
    if(attachment.usage === 'Modello3D'){
      accordionsGroupMap['disegni-2d-3d-title'] = getAccordion(attachment, accordionsGroupMap['disegni-2d-3d-title']);
    }
    if(attachment.usage === 'ZipDisegni' && process.env.NEXT_PUBLIC_ENABLE_ZIP === 'true'){
      accordionsGroupMap['disegni-2d-3d-title'] = setZipFIleUrl(attachment, accordionsGroupMap['zipdisegni-title']);
    }
    if(attachment.usage === 'IstruzioniMontaggio'){
      accordionsGroupMap['documentazione-title'] = getAccordion(attachment, accordionsGroupMap['documentazione-title']);
    }
    if(attachment.usage === 'ZipDocumentazione' && process.env.NEXT_PUBLIC_ENABLE_ZIP === 'true'){
      accordionsGroupMap['documentazione-title'] = setZipFIleUrl(attachment, accordionsGroupMap['zipdocumentazione-title']);
    }
    if(attachment.usage === 'PhotoElumdat'){
      accordionsGroupMap['fileilluminotecnici-title'] = getAccordion(attachment, accordionsGroupMap['fileilluminotecnici-title']);
    }
    if(attachment.usage === 'PhotoIesna'){
      accordionsGroupMap['fileilluminotecnici-title'] = getAccordion(attachment, accordionsGroupMap['fileilluminotecnici-title']);
    }
    if(attachment.usage === 'ULD'){
      accordionsGroupMap['fileilluminotecnici-title'] = getAccordion(attachment, accordionsGroupMap['fileilluminotecnici-title']);
    }
    if(attachment.usage === 'ZipFileIlluminotecnici' && process.env.NEXT_PUBLIC_ENABLE_ZIP === 'true'){
      accordionsGroupMap['fileilluminotecnici-title'] = setZipFIleUrl(attachment, accordionsGroupMap['zipfileilluminotecnici-title']);
    }
    if(attachment.usage === 'SchedaTecnica'){
      accordionsGroupMap['documentazione-title'] = getAccordion(attachment, accordionsGroupMap['documentazione-title']);
    }
    if(attachment.usage === 'ZipTutti' && process.env.NEXT_PUBLIC_ENABLE_ZIP === 'true'){
      accordionsGroupMap['ziptutti-title'] = setZipFIleUrl(attachment, accordionsGroupMap['ziptutti-title']);
    }
  });

  attachmentsGroupMapping.forEach((item: string) => {
    if(accordionsGroupMap[item].accordionRow.length > 0 && !item.includes('zip'))
      productData.attachmentsGrouped.push(accordionsGroupMap[item]);
    if(item === 'ziptutti-title' && process.env.NEXT_PUBLIC_ENABLE_ZIP === 'true') {
      productData.downloadAllDesktop = [
        {
          __typename: "DefaultTemplate_Fasce_Fasce_GrayCard_Links_LinkInterno",
          linkInterno: {
            id: "cG9zdDoxNA==",
            slug: "download",
            uri: "/download/" + accordionsGroupMap[item].accordionBtn[0].linkInterno.uri + "/download",
            title: "download"
          },
          label: t('download-all-desktop', {}, {default: 'Download tutti i documenti'}),
          target: null,
          variante: WPLinks_VARIANTE.filledButtonIcon,
          colore: WPLinks_COLORE.primary,
          dimensione: WPLinks_SIZE.large,
          icon: 'download'
        }
      ];
      productData.downloadAllMobile = [
        {
          __typename: "DefaultTemplate_Fasce_Fasce_GrayCard_Links_LinkInterno",
          linkInterno: {
            id: "cG9zdDoxNA==",
            slug: "download",
            uri: "/download/" + accordionsGroupMap[item].accordionBtn[0].linkInterno.uri + "/download",
            title: "download"
          },
          label: t('download-all-mobile', {}, {default: 'DOWNLOADS'}),
          target: null,
          variante: WPLinks_VARIANTE.filledButton,
          colore: WPLinks_COLORE.primary,
          dimensione: WPLinks_SIZE.large,
        }
      ];
    }


  });

  let modalData: ModalData = {
    //TODO dinamicizzare breadcrumb (stessa gestione pagina prodotto))
    breadcrumb: <Breadcrumb
    breadcrumbs={breadcrumbs}
  />,
  title: <ProductDetailTitle occhiello={parentProductName.replaceAll('&nbsp;',' ')} title={productData?.partNumber} titleBigMobile />,
  slider: <ProductDetailImage
    slide={[
      {
        backgroundImage: { id: 'pdp-image', mimeType: 'image/webp', mediaItemUrl: productData?.fullImage ? productData?.fullImage : defaultImage, mediaDetails: { width: 636, height: 636 } },
      }
    ]}
    showDots={false}
    showPreview
  />,
  tables: [
    <ProductOverlayTable
      key={0}
      title={t('technical-data-title')}
      iconList={productData?.iconList}
      table={productData?.technicalDataRow}
    />
  ],
  //TODO dinamicizzare gli attachments appena arriveranno da PIM (al momento = null per gli SKU)
  accordion: <ProductOverlayAccordion
    title="Downloads"
    accordions={productData.attachmentsGrouped}
    btnDownloadAll={productData.downloadAllDesktop}
    btnDownloadAllMobile={productData.downloadAllMobile}
    downloadGaranzia={{
      garanziaLink: garanzia,
      garanziaIcon: "document",
      garanziaLabel: t('garanzia-prodotto', {}, {default: 'Garanzia prodotto'}),
    }}
    useTag={{
      title: t('applicazioni-duso', {}, {default: "Applicazioni d'uso"}),
      tagList: [appUso]
    }}
  />,
  }
  return modalData;
}

const getAccordion = (atchm: any, accordionTemplate: any) => {
  let attach = {
    accordionIcon: getFileType(accordionTemplate.accordionType === 'fileilluminotecnici-title' ? atchm.longdesc : atchm.name),
    accordionLabel: accordionTemplate.accordionType === 'fileilluminotecnici-title' ? atchm.longdesc : atchm.name,
    downloadLink: atchm.identifier.indexOf('  ') > 0 ? normalizeAzureAssetUrl(atchm.identifier, '/') : normalizeAzureAssetUrl(atchm.attachmentAssetPath, '/')
  }
  accordionTemplate.accordionRow.push(attach);
  accordionTemplate.accordionBtn.push(atchm.attachmentAssetPath);
  console.log('attach: %s',JSON.stringify(accordionTemplate))
  return accordionTemplate;
}

const setZipFIleUrl = (atchm: any, accordionTemplate: any) => {
  accordionTemplate.accordionBtn[0].linkInterno.uri = normalizeAzureAssetUrl(atchm.attachmentAssetPath, '/');
  return accordionTemplate;
}

/* const getFileName = (filePath: string) => {
  let filePathSplit = filePath.split('/');
  console.log('name: ' + decodeURIComponent(filePathSplit[filePathSplit.length - 1].split('.')[0]));
  return decodeURIComponent(filePathSplit[filePathSplit.length - 1].split('.')[0]);
} */

const getFileType = (name: string) => {
  if(name !== null){
    // console.debug('name: ', name.split('.')?.pop()?.toLowerCase());
    return name.split('.')?.pop()?.toLowerCase() || 'default';
  }
  return null;
}
